import "./positionEdit.css";

import Component from "react-pure-render/component";
import React from "react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";
import Draggable from "react-draggable";

export default class PositionEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      offsetHeight: undefined
    };
  }

  componentDidMount() {
    const { field, actions, notificationSystem } = this.props;

    this.refs.dragImage.onload = () => {
      const offsetHeight =
        this.refs.dragImage && this.refs.dragImage.offsetHeight;
      this.setState({
        offsetHeight: offsetHeight
      });
    };
  }

  handleStop = (e, p) => {
    this.onChange(p.position.top * -1, p.node.clientHeight);
  };

  onChange = (value, height) => {
    const { actions, field, fields, ratio } = this.props;

    const maxValue = height - height * ratio;

    const v = (value + 6) / maxValue * 100 + "%";

    actions.setEntityField("fields", field.get("uid"), "value", v);
  };

  render() {
    const { apiHost, actions, field, fields, ratio } = this.props;

    const imagePlaceholder = field.get("placeholder").split("--")[0];

    const imageField = fields.get(imagePlaceholder);

    //const ratio = 300 / 1280;
    //

    const offsetHeight = this.state.offsetHeight;

    const divStyles = {
      height: ratio * offsetHeight + "px",
      overflow: "hidden"
    };
    let value = field.get("value").split("%");
    value = value && value[0] / 100;
    const initialTop = -1 * value * (offsetHeight - ratio * offsetHeight);

    return (
      <div className="col-xs-12">
        <div className="content-wrapper section">
          <div className="section-title">
            <span>{field.get("name")}</span>
          </div>
          <div className="move-image">
            <div style={divStyles}>
              {!isNaN(initialTop) && (
                <Draggable
                  axis="y"
                  handle=".handle"
                  start={{ x: 0, y: initialTop }}
                  bounds={{
                    top: -1 * (offsetHeight - ratio * offsetHeight),
                    bottom: 0
                  }}
                  grid={[1, 1]}
                  zIndex={100}
                  onStop={this.handleStop}
                >
                  <div ref="dragImage">
                    <img
                      draggable={false}
                      className="handle"
                      src={`${apiHost}/v1/files/${imageField.getIn([
                        "media",
                        "fileUID"
                      ])}/file`}
                    />
                  </div>
                </Draggable>
              )}
              {isNaN(initialTop) && (
                <div>
                  <img
                    ref="dragImage"
                    draggable={false}
                    className="handle"
                    src={`${apiHost}/v1/files/${imageField.getIn([
                      "media",
                      "fileUID"
                    ])}/file`}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/components/positionEdit.react.js